import request from 'local_modules/request'
import { reducers } from 'redux/core'
import { constants, getQuery } from 'helpers'


// busNumber [], routeNumber, []
const fetch = ({ filters: query = {}, fetchCount }) => {
  reducers.lscTransportControl.tableViolations.setFetching(true)

  const query1 = getQuery({
    busNumber: query.bus,
    routeNumber: query.route,
    startDate: query.dateFrom,
    endDate: query.dateTo,
    offset: query.offset || 0,
  })

  const query2 = getQuery({
    busNumber: query.bus,
    routeNumber: query.route,
    startDate: query.dateFrom,
    endDate: query.dateTo,
    offset: query.offset || 0,
    limit: query.limit,
  })

  return Promise.all([
    fetchCount ? request.get(constants.lscTransportControl.violationsCount + query1) : Promise.resolve({ data: {}}),
    request.get(constants.lscTransportControl.violations + query2)
  ])
    .then(([ { data: { count } }, { data: body }]) => {
      const data = body.map(({
       dateTime, // 01.03.2019 07:01",
       carrier, // Горавтотранс,
       violationType, //": null,
       busNumber, //": "М061УЕ52",
       routeNumber, //": "1"
      }) => ({
        bus: busNumber, //: "681",
        date: dateTime, //: "2018-12-04T00:00:00.000Z",
        violationType,
        carrier,
        route: routeNumber, //: "3"
      }))

      if (data.length > query.limit) {
        reducers.lscTransportControl.tableViolations.setData(
          [...data].splice(query.offset || 0, query.limit || 10)
        )
      }
      else {
        reducers.lscTransportControl.tableViolations.setData(data)
      }

      if (count) {
        reducers.lscTransportControl.tableViolations.setPages(Math.ceil(count / (query.limit || 10)))
      }

      // if (!query.offset) {
      //   reducers.lscTransportControl.tableViolations.setActivePageId(1)
      // }

      reducers.lscTransportControl.tableViolations.setFetching(false)
    })
    .catch((err) => {
      console.log(err)
      reducers.lscTransportControl.tableViolations.setFetching(false)
    })
}


const setActivePageId = (activePageId) =>
  reducers.lscTransportControl.tableViolations.setActivePageId(activePageId)

const setPages = (pages) =>
  reducers.lscTransportControl.tableViolations.setPages(pages)


export default {
  fetch,
  setPages,
  setActivePageId,
}
